
import { Product } from "@/lib/types";
import LowStockAlert from "@/components/LowStockAlert";

interface AlertsSectionProps {
  lowStockProducts: Product[];
  onDismissAlert: (productId: string) => void;
  onAddStock: (product: Product) => void;
}

const AlertsSection = ({
  lowStockProducts,
  onDismissAlert,
  onAddStock
}: AlertsSectionProps) => {
  if (lowStockProducts.length === 0) return null;
  
  return (
    <section className="mb-3 max-w-3xl mx-auto">
      <LowStockAlert 
        products={lowStockProducts}
        onDismiss={onDismissAlert}
        onAddStock={onAddStock}
      />
    </section>
  );
};

export default AlertsSection;
